import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/header";
import { useAuth } from "../hooks/AuthContext";
import { ButtonC } from "../components/simple";
import ModalC from "../components/modal";
import api from "../services/api";
import loadingBranco from "./../images/loadingBranco.gif";
import { toast } from "react-toastify";
import { Layout } from "antd";
import { Content } from "antd/es/layout/layout";
import Menu from "../components/Menu";
import Chat from "../components/Chat";
const { Sider } = Layout;

const RouteFranqueados = () => {
  const user = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [statements, setStatements] = useState([]);

  useEffect(() => {
    let type = "";
    if (user.user) {
      type = user.user.type;
    }

    if (!type) {
      window.location.assign("/login");
    } else {
      if (type != "cliente") {
        if (type == "tecnico") {
          window.location.assign("/tecnicos/home");
        } else {
          if (type == "atendente") {
            window.location.assign("/atendimentos");
          } else {
            window.location.assign("/admin/home");
          }
        }
      }
    }
  }, []);

  useEffect(() => {
    loadStatements();
  }, []);

  async function loadStatements(page) {
    await api
      .get(`/statements-user`)
      .then((response) => {
        setStatements(response.data);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function confirmStatement(statement) {
    setIsLoading(true);
    await api
      .put(`/confirm-statement/${statement.id}`)
      .then(() => {
        setStatements(statements.filter((item) => item.id != statement.id));
        toast.success(
          "Confirmação de leiturda do comunicado realizada com sucesso"
        );
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  let type = "";
  if (user.user) {
    type = user.user.type;
  }

  return type == "cliente" ? (
    <Layout>
      <Header sidebar={true} />
      <Layout>
        <Sider
          style={{ background: "#008037", minHeight: "calc(100vh - 70px" }}
          width={230}
          trigger={null}
          collapsedWidth={0}
          breakpoint={"xl"}
        >
          <Menu />
        </Sider>
        <Content className="content">
          <Outlet />
          <Chat />
        </Content>
      </Layout>
      {statements.map((item) => (
        <ModalC visible={true} executar={() => {}}>
          <div
            style={{
              paddingTop: 0,
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <h3
              style={{
                width: "90%",
                fontSize: 17,
                margin: "15px 0",
                textAlign: "center",
                color: "#fff",
              }}
            >
              {item.title}
            </h3>
            <p
              style={{
                width: "90%",
                fontSize: 17,
                margin: "15px 0",
                textAlign: "center",
                color: "#fff",
              }}
            >
              {item.description}
            </p>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  width: "100%",
                  justifyContent: "center",
                  marginTop: 25,
                }}
              >
                <ButtonC
                  text={""}
                  title={
                    isLoading ? (
                      <img
                        src={loadingBranco}
                        style={{
                          background: "transparent",
                          height: 40,
                          width: 40,
                          margin: "0 40px",
                        }}
                      />
                    ) : (
                      "Confirmar"
                    )
                  }
                  disabled={isLoading}
                  background={"#25b03a"}
                  width={"100%"}
                  executar={() => {
                    confirmStatement(item);
                  }}
                />
              </div>
            </div>
          </div>
        </ModalC>
      ))}
    </Layout>
  ) : (
    <></>
  );
};

export default RouteFranqueados;
